import { createAction, handleActions } from 'redux-actions';
import { API_SUCCESSION_TALENT_POOLS } from 'constants/apiRoutes';
import { SUCCESSION_POOLS_DEFAULT_PARAMS } from 'constants/pages';
import http from 'utility/http';
import { parseDuplicateParameters } from 'utility/uiUtils';

// ------------------------------------
// Constants
// ------------------------------------

const SET_SUCCESSION_POOLS = 'SET_SUCCESSION_POOLS';
const LOAD_MORE_SUCCESSION_POOLS = 'LOAD_MORE_SUCCESSION_POOLS';

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {};

// ------------------------------------
// Actions
// ------------------------------------

const setSuccessionPools = createAction(SET_SUCCESSION_POOLS);
const loadMoreSuccessionPools = createAction(LOAD_MORE_SUCCESSION_POOLS);
// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_SUCCESSION_POOLS]: (state, { payload }) => ({ ...payload }),
  [LOAD_MORE_SUCCESSION_POOLS]: (state, { payload }) => ({
    ...state,
    ...payload,
    results: state.results
      ? [...state.results, ...payload.results]
      : [...payload.results],
  }),
};

// ------------------------------------
// API calls
// ------------------------------------

export const getSuccessionPools = (dispatch, isLoadMore = false, params = {}) =>
  http
    .get(API_SUCCESSION_TALENT_POOLS, {
      params: { ...SUCCESSION_POOLS_DEFAULT_PARAMS, ...params },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      if (isLoadMore) {
        dispatch(loadMoreSuccessionPools(data));
      } else {
        dispatch(setSuccessionPools(data));
      }
      return data;
    });

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearSuccessionPools = () => setSuccessionPools(initialState);
